<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="invokeMethod($event)" dialog-model="customer_dialog" perm="companies.create"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetCustomers()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="customers" :no-data-text="$t('lang.no_data_available')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="profile(props.item.company_id)">
                                <td><img :src="props.item.logo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                                <td>
                                    <v-chip label text-color="white" :color="props.item.status_class">
                                        <span
                                            ><v-icon>{{ props.item.status_icon }}</v-icon></span
                                        >
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" path="/customers"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog v-model="customer_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.addCustomer") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="customer_dialog"
                            :dialog-status="customer_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form_customer" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="customer_dialog"
                                            v-model="customer.company"
                                            :label="`${$t('lang.company')} *`"
                                            :counter="showCounter(customer.company, 'customer.company')"
                                            :rules="ifValid('customer.company')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-switch
                            v-model="profile_onsave"
                            :label="profile_onsave ? $t('lang.after_save_profile') : $t('lang.after_save_stay')"
                            ripple
                            class="my-0 pa-0"
                        ></v-switch>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="customer_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn v-if="hasPerm('companies.create')" color="success" @mouseup.left="add()">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import AppConfig from "Constants/AppConfig";
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: "", sortable: false, align: "center", width: "60" },
                { text: this.$t("lang.company"), sortable: false },
                { text: "", sortable: false, align: "center", width: "60" },
            ],
            customer: {
                company: "",
            },
            filter: {
                search: "",
                status: "1",
                user_id: "",
                with_tokens: "",
                module: "",
                page_size: 0,
                page_num: 1,
            },
            profile_onsave: true,
            customer_dialog: false,
            dbGetCustomers: _.debounce(this.getCustomers, 1500, { maxWait: 1500, leading: true, trailing: false }),
            mobileList: [
                { title: this.$t("lang.addNew"), action: "control_dialog", dialog_model: "customer_dialog", status: true, perms: ["companies.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetCustomers" },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchCustomers", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.customers) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchCustomers", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.customers) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetCustomers");
        next();
    },
    computed: {
        ...mapState({
            rules_customer: (state) => state.customers.rules_customers,
            default_filter: (state) => state.customers.customers_filter,
            customers: (state) => state.customers.customers,
            page: (state) => state.customers.page,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchCustomers", "saveCustomer", "deleteCustomer"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        getCustomers() {
            this.startLoader();

            let parsedQuery = JSON.parse(JSON.stringify(this.$route.query));
            this.fetchCustomers({
                body: parsedQuery,
            }).then((data) => {
                if (typeof data !== "undefined" && data.customers) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                } else {
                    this.finishLoader(true);
                    this.$router.push({ name: "dashboard" });
                }
            });
        },
        imageLoadError(event) {
            event.target.src = AppConfig.defaultProfileLogo;
        },
        profile(id) {
            this.$router.push({ name: "customers_profile", params: { id: id } });
        },
        add() {
            this.validationOn();

            this.$nextTick(() => {
                if (this.validateForm("form_customer")) {
                    this.toggleModalLoader(true);
                    let body = this.prepForm(this.customer, this.rules_customer);

                    this.saveCustomer({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.customer) {
                            if (this.profile_onsave) {
                                this.$router.push({ name: "customers_profile", params: { id: data.customer.company_id } });
                            } else {
                                this.toggleModalLoader(false);
                                this.validationOff();
                                this.customer = { company: "" };
                            }
                        } else {
                            this.toggleModalLoader(false);
                        }
                    });
                }
            });

            /*this.$nextTick(() => {
                if (this.validateForm("customer")) {
                    this.toggleModalLoader(true);

                    this.$store
                        .dispatch("fetchCustomers", {
                            pk: "customer_id",
                            url: "customers",
                            method: "post",
                            stateProperty: "customers",
                            dataProperty: "customer",
                            mutate: true,
                            body: this.customer,
                        })
                        .then((data) => {
                            if (data && data.customer) {
                                console.log(data.customer);
                                if (this.profile_onsave) {
                                    this.$router.push({ name: "customers_profile", params: { id: data.customer.company_id } });
                                } else {
                                    this.toggleModalLoader(false);
                                    this.validationOff();
                                    this.assignObj(this.customer, null, this.rules_customer);
                                }
                            } else {
                                this.toggleModalLoader(false);
                            }
                        });
                }
            });*/
        },
    },
};
</script>
